"use strict";

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var Navbar = /*#__PURE__*/function (_React$Component) {
  _inherits(Navbar, _React$Component);

  var _super = _createSuper(Navbar);

  function Navbar() {
    _classCallCheck(this, Navbar);

    return _super.apply(this, arguments);
  }

  _createClass(Navbar, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("nav", {
        className: 'navbar navbar-expand-lg ' + this.props.className
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/",
        className: "navbar-brand",
        "aria-label": this.props.logoAria
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: this.props.logo,
        alt: "",
        className: "brand-img"
      })), /*#__PURE__*/_react["default"].createElement("button", {
        className: "navbar-toggler",
        type: "button",
        "data-toggle": "collapse",
        "data-target": ".navbar-collapse",
        "aria-controls": "navbarSupportedContent",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "navbar-toggler-icon"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "collapse navbar-collapse text-center",
        id: "navbarSupportedContent"
      }, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "navbar-nav ".concat(this.props.centered ? 'w-100 justify-content-center' : 'mr-auto')
      }, this.props.pages.map(function (page) {
        return page.subPages ? /*#__PURE__*/_react["default"].createElement("li", {
          className: "nav-item dropdown",
          key: page.name
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: "nav-link dropdown-toggle",
          href: "#",
          id: "".concat(page.name, "NavbarDropdown"),
          role: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }, page.name.toUpperCase()), /*#__PURE__*/_react["default"].createElement("div", {
          className: "dropdown-menu",
          "aria-labelledby": "".concat(page.name, "NavbarDropdown")
        }, page.subPages.map(function (subPage) {
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: "dropdown-item",
            href: subPage.link,
            key: subPage.name
          }, subPage.name.toUpperCase());
        }))) : /*#__PURE__*/_react["default"].createElement("li", {
          className: "nav-item",
          key: page.name
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: page.link,
          className: "nav-link"
        }, page.name.toUpperCase()));
      }))), this.props.children);
    }
  }]);

  return Navbar;
}(_react["default"].Component);

Navbar.propTypes = {
  children: _propTypes["default"].node,
  logo: _propTypes["default"].any,
  pages: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    link: _propTypes["default"].string,
    subPages: _propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      link: _propTypes["default"].string.isRequired
    })
  }).isRequired).isRequired
};
var _default = Navbar;
exports["default"] = _default;